module.exports = __webpack_public_path__ + "img/disapproval.cb5421ea.svg";